export default function calculateConditionRating(rating) {
  if (typeof rating === 'string') {
    rating = parseFloat(rating);
  }

  switch (true) {
    case (rating < 50):
      return 5;
    case (rating >= 50 && rating < 75):
      return 4;
    case (rating >= 75 && rating < 95):
      return 3;
    case (rating >= 95 && rating < 100):
      return 2;
    case (rating === 100):
      return 1;
    default:
      return 0;
  }
}
